<template>
  <DialogWrapper
    isMobile
    :show.sync="isShow"
    :title="$t(`${i18nPrefix}.label.updateMobilePhone`)"
    @save="onSubmit"
  >
    <UpdateMobile
      class="update-mobile"
      ref="updateMobile"
      :isShow="isShow"
      :phone="phone"
      :countryCode="countryCode"
      :jobId="jobId"
      :captchaIndex="captchaIndex"
      :isCandidate="isCandidate"
      :companyId="companyId"
      @success="updateMobileSuccess"
    ></UpdateMobile>
  </DialogWrapper>
</template>

<script>
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'
import UpdateMobile from '../editor/updateMobile.vue'

export default {
  components: {
    UpdateMobile,
    DialogWrapper
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    phone: {
      type: String
    },
    countryCode: {
      type: String
    },
    jobId: {
      default: null
    },
    captchaIndex: {
      type: Number,
      required: true
    },
    isCandidate: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      i18nPrefix: 'admin.application.candidate'
    }
  },
  computed: {
    isShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', val)
      }
    }
  },
  created () {

  },
  methods: {
    async onSubmit () {
      await this.$refs.updateMobile.onSubmit()
    },
    updateMobileSuccess (formData) {
      this.$emit('success', formData)
      this.isShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.update-mobile {
  ::v-deep {
    .verify-code-input {
      .verify-code {
        .send-verify-code {
          color: var(--custom-color, #0096cc);
        }

        .el-input__inner {
          &:focus + .el-input-group__append {
            border-color: var(--custom-color, #0096cc);
          }
        }
      }
    }

    .form-line {
      .line-input {
        .el-input__inner {
          &:focus {
            border-color: var(--custom-color, #0096cc);
          }
        }
      }
    }

    .country-code-popper {
      .el-select-dropdown__item {
        &.selected {
          color: var(--custom-color, #0096cc);
        }
      }
    }
  }
}
</style>
